import { render, staticRenderFns } from "./canadaView.vue?vue&type=template&id=cac5a976&scoped=true"
import script from "./canadaView.vue?vue&type=script&lang=js"
export * from "./canadaView.vue?vue&type=script&lang=js"
import style0 from "./canadaView.vue?vue&type=style&index=0&id=cac5a976&prod&lang=less&scoped=true"
import style1 from "./canadaView.vue?vue&type=style&index=1&id=cac5a976&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac5a976",
  null
  
)

export default component.exports